<template>
	<div class="loader">
		<i class="onestore-theme-secondary fa fa-cog fa-spin fa-2x"></i>
	</div>
</template>

<script>
export default {
  name: "loader"
};
</script>

<style scoped>
.loader {
  text-align: center;
  margin-top: 20px;
  margin-bottom:20px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Loader.vue